import React from "react"
import { ModeloIzzaGPTContextProvider } from "./context/ModeloIzzaGPTContextProvider"
import { ModeloIzzaGPTPage } from "./ModeloIzzaGPT"

export function Index() {
    return (
        <ModeloIzzaGPTContextProvider>
            <ModeloIzzaGPTPage />
        </ModeloIzzaGPTContextProvider>
    )
}
